/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RoadmapAuditFindingsResponse } from '../models/RoadmapAuditFindingsResponse';
import type { RoadmapDependencyRowPage } from '../models/RoadmapDependencyRowPage';
import type { RoadmapDependencySummaryResponse } from '../models/RoadmapDependencySummaryResponse';
import type { RoadmapFacetsResponse } from '../models/RoadmapFacetsResponse';
import type { RoadmapHierarchyResponse } from '../models/RoadmapHierarchyResponse';
import type { RoadmapNavigationResponse } from '../models/RoadmapNavigationResponse';
import type { RoadmapPersonScopeResponse } from '../models/RoadmapPersonScopeResponse';
import type { RoadmapRollupResponse } from '../models/RoadmapRollupResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RoadmapService {

    /**
     * Get Roadmap Person Scope
     * Return one searched person and their active reporting subtree.
     * @param employeeId
     * @returns RoadmapPersonScopeResponse Successful Response
     * @throws ApiError
     */
    public static getRoadmapPersonScopeApiV1RoadmapPeopleEmployeeIdScopeGet(
        employeeId: string,
    ): CancelablePromise<RoadmapPersonScopeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/roadmap/people/{employee_id}/scope',
            path: {
                'employee_id': employeeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Roadmap Facets
     * Return data-driven timeframes and generic scope roots.
     * @returns RoadmapFacetsResponse Successful Response
     * @throws ApiError
     */
    public static getRoadmapFacetsApiV1RoadmapFacetsGet(): CancelablePromise<RoadmapFacetsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/roadmap/facets',
        });
    }

    /**
     * Get Roadmap Hierarchy
     * Return generic v2 nodes, optionally scoped to one timeframe or root.
     * @param timeframe
     * @param scopeKey
     * @param groupIds Stable Jira Group option IDs combined as a union.
     * @returns RoadmapHierarchyResponse Successful Response
     * @throws ApiError
     */
    public static getRoadmapHierarchyApiV1RoadmapHierarchyGet(
        timeframe?: (string | null),
        scopeKey?: (string | null),
        groupIds?: (Array<string> | null),
    ): CancelablePromise<RoadmapHierarchyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/roadmap/hierarchy',
            query: {
                'timeframe': timeframe,
                'scope_key': scopeKey,
                'group_ids': groupIds,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Roadmap Navigation
     * Return the compact structural hierarchy used by navigation.
     * @param timeframe
     * @returns RoadmapNavigationResponse Successful Response
     * @throws ApiError
     */
    public static getRoadmapNavigationApiV1RoadmapNavigationGet(
        timeframe?: (string | null),
    ): CancelablePromise<RoadmapNavigationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/roadmap/navigation',
            query: {
                'timeframe': timeframe,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Roadmap Rollup
     * Return ordered structural and quarter-aware Roadmap rollups.
     * @param timeframe
     * @param quarter
     * @param scopeKey
     * @param groupIds Stable Jira Group option IDs combined as a union.
     * @param assignee Scope Roadmap initiatives to the authenticated employee.
     * @param assigneeScopeEmployeeId Employee whose active reporting subtree scopes Roadmap initiatives.
     * @returns RoadmapRollupResponse Successful Response
     * @throws ApiError
     */
    public static getRoadmapRollupApiV1RoadmapRollupGet(
        timeframe: string,
        quarter: string,
        scopeKey?: (string | null),
        groupIds?: (Array<string> | null),
        assignee: 'all' | 'me' = 'all',
        assigneeScopeEmployeeId?: (string | null),
    ): CancelablePromise<RoadmapRollupResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/roadmap/rollup',
            query: {
                'timeframe': timeframe,
                'quarter': quarter,
                'scope_key': scopeKey,
                'group_ids': groupIds,
                'assignee': assignee,
                'assignee_scope_employee_id': assigneeScopeEmployeeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Summarize Roadmap Dependencies
     * Returns generation-consistent KPI cards, disjunctive facets, and the selected filtered group manifest without downloading rows.
     * @param timeframe Roadmap or Dependency group key.
     * @param scopeKey Optional Roadmap scope key.
     * @param quarter Canonical Planning Quarter, such as 2026-q3.
     * @param includeBeforeQuarter Include valid Planning Quarters before the selection.
     * @param view Grouping view: delivering_group, requesting_group, sub_workstream, status, priority, or action_needed.
     * @param status Repeat to OR values within this filter facet.
     * @param priority Repeat to OR values within this filter facet.
     * @param actionNeeded Optional Action Needed filter.
     * @param assigned Identity selector: all or authenticated-user me.
     * @param requested Identity selector: all or authenticated-user me.
     * @param query Case-insensitive Dependency list search.
     * @param participantEmployeeId Employee ID that must match either the Dependency assignee or requestor.
     * @param participantScopeEmployeeId Employee whose active reporting subtree scopes Dependency participants.
     * @param groupIds Stable Jira Group option IDs combined as a union.
     * @returns RoadmapDependencySummaryResponse Successful Response
     * @throws ApiError
     */
    public static getRoadmapDependenciesApiV1RoadmapDependenciesGet(
        timeframe: string,
        scopeKey?: (string | null),
        quarter?: (string | null),
        includeBeforeQuarter: boolean = false,
        view?: (string | null),
        status?: (Array<string> | null),
        priority?: (Array<string> | null),
        actionNeeded?: (boolean | null),
        assigned?: (string | null),
        requested?: (string | null),
        query?: (string | null),
        participantEmployeeId?: (string | null),
        participantScopeEmployeeId?: (string | null),
        groupIds?: (Array<string> | null),
    ): CancelablePromise<RoadmapDependencySummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/roadmap/dependencies',
            query: {
                'timeframe': timeframe,
                'scope_key': scopeKey,
                'quarter': quarter,
                'include_before_quarter': includeBeforeQuarter,
                'view': view,
                'status': status,
                'priority': priority,
                'action_needed': actionNeeded,
                'assigned': assigned,
                'requested': requested,
                'query': query,
                'participant_employee_id': participantEmployeeId,
                'participant_scope_employee_id': participantScopeEmployeeId,
                'group_ids': groupIds,
            },
            errors: {
                404: `No complete Dependency generation is available.`,
                409: `The row token belongs to a retired generation.`,
                422: `One or more Dependency filters are invalid.`,
                503: `The Dependency read index is unavailable.`,
            },
        });
    }

    /**
     * Page Roadmap Dependency rows
     * Returns one signed-cursor row page for a group and optional status filter. Selection parameters are rebound into every cursor.
     * @param snapshotToken Opaque Dependency snapshot token from the summary.
     * @param timeframe Roadmap or Dependency group key.
     * @param groupKey Roadmap or Dependency group key.
     * @param scopeKey Optional Roadmap scope key.
     * @param quarter Canonical Planning Quarter, such as 2026-q3.
     * @param includeBeforeQuarter
     * @param view Grouping view: delivering_group, requesting_group, sub_workstream, status, priority, or action_needed.
     * @param status Repeat to OR values within this filter facet.
     * @param priority Repeat to OR values within this filter facet.
     * @param actionNeeded Optional Action Needed filter.
     * @param assigned Identity selector: all or authenticated-user me.
     * @param requested Identity selector: all or authenticated-user me.
     * @param query Case-insensitive Dependency list search.
     * @param limit
     * @param cursor Opaque signed continuation cursor.
     * @param participantEmployeeId Employee ID that must match either the Dependency assignee or requestor.
     * @param participantScopeEmployeeId Employee whose active reporting subtree scopes Dependency participants.
     * @param groupIds Stable Jira Group option IDs combined as a union.
     * @returns RoadmapDependencyRowPage Successful Response
     * @throws ApiError
     */
    public static getRoadmapDependencyRowsApiV1RoadmapDependenciesRowsGet(
        snapshotToken: string,
        timeframe: string,
        groupKey: string,
        scopeKey?: (string | null),
        quarter?: (string | null),
        includeBeforeQuarter: boolean = false,
        view?: (string | null),
        status?: (Array<string> | null),
        priority?: (Array<string> | null),
        actionNeeded?: (boolean | null),
        assigned?: (string | null),
        requested?: (string | null),
        query?: (string | null),
        limit: number = 50,
        cursor?: (string | null),
        participantEmployeeId?: (string | null),
        participantScopeEmployeeId?: (string | null),
        groupIds?: (Array<string> | null),
    ): CancelablePromise<RoadmapDependencyRowPage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/roadmap/dependencies/rows',
            query: {
                'snapshot_token': snapshotToken,
                'timeframe': timeframe,
                'group_key': groupKey,
                'scope_key': scopeKey,
                'quarter': quarter,
                'include_before_quarter': includeBeforeQuarter,
                'view': view,
                'status': status,
                'priority': priority,
                'action_needed': actionNeeded,
                'assigned': assigned,
                'requested': requested,
                'query': query,
                'limit': limit,
                'cursor': cursor,
                'participant_employee_id': participantEmployeeId,
                'participant_scope_employee_id': participantScopeEmployeeId,
                'group_ids': groupIds,
            },
            errors: {
                404: `No complete Dependency generation is available.`,
                409: `The row token belongs to a retired generation.`,
                422: `One or more Dependency filters are invalid.`,
                503: `The Dependency read index is unavailable.`,
            },
        });
    }

    /**
     * Get Scopes
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getScopesApiV1RoadmapScopesGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/roadmap/scopes',
        });
    }

    /**
     * Get Launches
     * @param scope
     * @param quarter
     * @param timeframe
     * @param scopeKey
     * @param groupIds Stable Jira Group option IDs combined as a union.
     * @param assignee Scope Roadmap initiatives to the authenticated employee.
     * @param assigneeScopeEmployeeId Employee whose active reporting subtree scopes Roadmap initiatives.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getLaunchesApiV1RoadmapLaunchesGet(
        scope?: (string | null),
        quarter?: (string | null),
        timeframe?: (string | null),
        scopeKey?: (string | null),
        groupIds?: (Array<string> | null),
        assignee: 'all' | 'me' = 'all',
        assigneeScopeEmployeeId?: (string | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/roadmap/launches',
            query: {
                'scope': scope,
                'quarter': quarter,
                'timeframe': timeframe,
                'scope_key': scopeKey,
                'group_ids': groupIds,
                'assignee': assignee,
                'assignee_scope_employee_id': assigneeScopeEmployeeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Roadmap
     * @param scope
     * @param quarter
     * @param timeframe
     * @param scopeKey
     * @param groupIds Stable Jira Group option IDs combined as a union.
     * @param assignee Scope Roadmap initiatives to the authenticated employee.
     * @param assigneeScopeEmployeeId Employee whose active reporting subtree scopes Roadmap initiatives.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getRoadmapApiV1RoadmapRoadmapGet(
        scope?: (string | null),
        quarter?: (string | null),
        timeframe?: (string | null),
        scopeKey?: (string | null),
        groupIds?: (Array<string> | null),
        assignee: 'all' | 'me' = 'all',
        assigneeScopeEmployeeId?: (string | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/roadmap/roadmap',
            query: {
                'scope': scope,
                'quarter': quarter,
                'timeframe': timeframe,
                'scope_key': scopeKey,
                'group_ids': groupIds,
                'assignee': assignee,
                'assignee_scope_employee_id': assigneeScopeEmployeeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Allocations
     * @param scope
     * @param quarter
     * @param timeframe
     * @param scopeKey
     * @param groupIds Stable Jira Group option IDs combined as a union.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getAllocationsApiV1RoadmapAllocationsGet(
        scope?: (string | null),
        quarter?: (string | null),
        timeframe?: (string | null),
        scopeKey?: (string | null),
        groupIds?: (Array<string> | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/roadmap/allocations',
            query: {
                'scope': scope,
                'quarter': quarter,
                'timeframe': timeframe,
                'scope_key': scopeKey,
                'group_ids': groupIds,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Roadmap Audit Findings
     * Return one generation-consistent page of indexed audit findings.
     * @param timeframe
     * @param quarter
     * @param scopeKey
     * @param assignee
     * @param assigneeKey
     * @param assigneeScopeEmployeeId Employee whose active reporting subtree scopes assignee results.
     * @param ruleId
     * @param ruleMode
     * @param status
     * @param query
     * @param cursor
     * @param limit
     * @param groupIds Stable Jira Group option IDs combined as a union.
     * @returns RoadmapAuditFindingsResponse Successful Response
     * @throws ApiError
     */
    public static getRoadmapAuditFindingsApiV1RoadmapAuditFindingsGet(
        timeframe: string,
        quarter: string,
        scopeKey?: (string | null),
        assignee: 'all' | 'me' = 'all',
        assigneeKey?: (Array<string> | null),
        assigneeScopeEmployeeId?: (string | null),
        ruleId?: (Array<string> | null),
        ruleMode: 'any' | 'all' = 'any',
        status?: (Array<string> | null),
        query?: (string | null),
        cursor?: (string | null),
        limit: number = 50,
        groupIds?: (Array<string> | null),
    ): CancelablePromise<RoadmapAuditFindingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/roadmap/audit/findings',
            query: {
                'timeframe': timeframe,
                'quarter': quarter,
                'scope_key': scopeKey,
                'assignee': assignee,
                'assignee_key': assigneeKey,
                'assignee_scope_employee_id': assigneeScopeEmployeeId,
                'rule_id': ruleId,
                'rule_mode': ruleMode,
                'status': status,
                'query': query,
                'cursor': cursor,
                'limit': limit,
                'group_ids': groupIds,
            },
            errors: {
                404: `No complete Roadmap generation is available.`,
                409: `The cursor belongs to a retired generation.`,
                422: `One or more audit filters are invalid.`,
                503: `No compatible audit index is available.`,
            },
        });
    }

    /**
     * Get Audit
     * @param scope
     * @param quarter
     * @param timeframe
     * @param scopeKey
     * @param groupIds Stable Jira Group option IDs combined as a union.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getAuditApiV1RoadmapAuditGet(
        scope?: (string | null),
        quarter?: (string | null),
        timeframe?: (string | null),
        scopeKey?: (string | null),
        groupIds?: (Array<string> | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/roadmap/audit',
            query: {
                'scope': scope,
                'quarter': quarter,
                'timeframe': timeframe,
                'scope_key': scopeKey,
                'group_ids': groupIds,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
